import React, { useState ,useEffect} from 'react';
import { useParams, useLocation } from 'react-router-dom';
import api from "../api";

const ResetPasswordPage = () => {
  useEffect(() => {
    document.title = "Reset Password | Workgear365";
  }, []);
  const { token } = useParams();
  const query = new URLSearchParams(useLocation().search);
  const email = query.get('email');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post('/api/reset-password', {
        email,
        token,
        password,
        password_confirmation: confirmPassword,
      });

      setMessage(response.data.message || 'Password reset successfully');
    } catch (error) {
      if (error.response?.data?.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage('Something went wrong.');
      }
    }
  };

  return (
   <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="card shadow">
            <div className="card-header text-white">
              <h4 className="mb-0">Reset Password</h4>
            </div>
            <div className="card-body p-4">
             {message && <div className="alert alert-info">{message}</div>}
             
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
                
        <input
          type="password"
          placeholder="New Password"
          value={password}
          className="form-control"
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        </div>
        <div className='mb-3'>
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          className="form-control"
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        </div>
        <button className="btn btn-primary w-100" type="submit">Reset Password</button>
      </form>
     </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
